// @flow

import type { Node } from 'react';

import { Info } from 'lucide-react';
import { View, Text, Tooltip, Button } from 'reshaped';

import type { TotalTax } from '@gandi/billing';
import type { Tax } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

type Props = {
  tax: TotalTax | Tax,
  currency: string,
};

function useTaxLabels({ rate = 0 }: TotalTax | Tax) {
  const { __ } = useTranslator();

  return {
    zipcode: [__('Local/State tax')],
    vat: [__('Sales Tax'), __('VAT %(rate)s%%', { rate })],
  };
}

export default function TotalTaxRow({ tax, currency }: Props): Node {
  const translator = useTranslator();
  const { __, formatPrice } = translator;

  // $FlowFixMe[invalid-computed-prop]
  // $FlowFixMe[prop-missing] fix Billing or Cart name type. 'notax' name ?
  const { [tax.name]: taxLabels } = useTaxLabels(tax);

  return (
    <View direction="row" justify="space-between">
      <View direction="row" gap={2} align="center">
        <Text as="p" variant="body-3">
          {taxLabels[0]}
        </Text>

        {taxLabels[1] && (
          <Text as="p" color="neutral-faded">
            {taxLabels[1]}
          </Text>
        )}

        {tax.name === 'zipcode' && (
          <Tooltip
            text={__('This is the combined amount of your state and local tax')}
          >
            {attributes => {
              const buttonAttributes: any = {
                ...attributes,
                'aria-label': __(
                  'This is the combined amount of your state and local tax',
                ),
              };

              return (
                <Button
                  attributes={buttonAttributes}
                  icon={Info}
                  variant="ghost"
                  size="small"
                  color="neutral"
                />
              );
            }}
          </Tooltip>
        )}
      </View>
      <Text as="p" variant="body-3">
        {/* $FlowFixMe amount is missing in Tax type */}
        {formatPrice(tax.amount, currency)}
      </Text>
    </View>
  );
}
